import { render, staticRenderFns } from "./CropZoneItem.vue?vue&type=template&id=63e522ad&scoped=true&"
import script from "./CropZoneItem.vue?vue&type=script&lang=js&"
export * from "./CropZoneItem.vue?vue&type=script&lang=js&"
import style0 from "./CropZoneItem.vue?vue&type=style&index=0&id=63e522ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e522ad",
  null
  
)

export default component.exports